import React, { useEffect } from "react"
import * as Leaflet from "leaflet"
import { Map, TileLayer, Marker, Popup } from "react-leaflet"
import { GestureHandling } from "leaflet-gesture-handling"

import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css"

const LeafletMap = () => {
  useEffect(() => {
    delete Leaflet.Icon.Default.prototype._getIconUrl
    Leaflet.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    })
    Leaflet.Map.addInitHook("addHandler", "gestureHandling", GestureHandling)
  }, [])

  const position = [-28.051014, -56.018059]
  if (typeof window !== "undefined") {
    return (
      <Map
        center={position}
        zoom={17}
        style={{ width: "inherit", height: "inherit" }}
        gestureHandling
      >
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>Laboratorio Debat</Popup>
        </Marker>
      </Map>
    )
  }
  return null
}

export default LeafletMap
